import { map, chain, take } from "lodash"
import PropTypes from "prop-types"
import classNames from "classnames"
import EllipsableItem from "./ellipsable-item"

export function TopXAccordionDetails({ columns, labelFormatter, valueGetter, formatter, color, all, rowCount }) {
  return <div className="label">
    <div style={{ backgroundColor: color }} />
    <div />
    {map(columns, (columnRows, id) => {
      return <div className="column" key={id}>
        {chain(columnRows)
          .thru(columnRows => all ? columnRows : take(columnRows, rowCount))
          .map((positionOrGroup, i) =>
            <EllipsableItem
              key={`${id}-${i}`}
              label={labelFormatter(positionOrGroup)}
              value={formatter(valueGetter(positionOrGroup))}
              barWidth={Math.abs(valueGetter(positionOrGroup))}
            />)
          .value()}
        <div />
      </div>
    },
    )}
  </div>
}

TopXAccordionDetails.propTypes = {
  columns: PropTypes.array.isRequired,
  labelFormatter: PropTypes.func.isRequired,
  valueGetter: PropTypes.func.isRequired,
  formatter: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  all: PropTypes.bool.isRequired,
  rowCount: PropTypes.number.isRequired,
}

export function TableAccordionDetails({ rows, labelFormatter, formatter, color }) {
  return map(rows, (row, id) => {
    return <div key={id}>
      <div style={{ backgroundColor: color }} />
      <div data-test-class="compare-table-value" className={classNames("label", { "tooltip-label": row.tooltip })}>{labelFormatter(row)}</div>
      {map(row.values, (value, index) => <div key={index} data-test-class="compare-table-value">{formatter(value)}</div>)}
    </div>
  },
  )
}

TableAccordionDetails.propTypes = {
  rows: PropTypes.array.isRequired,
  labelFormatter: PropTypes.func.isRequired,
  valueGetter: PropTypes.func.isRequired,
  formatter: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
}
